module.exports = __webpack_public_path__ + "img/subscription__image.cffc2529.png";